import React from 'react';
import {RoleGuard} from "../../components/PermissionGuard";
import {StandardLayout} from "../../components/StandardLayout";
import {DashboardFeature} from "../../features/dashboard";

const ALLOWED_ROLES = ['god']

interface DashboardPageProps {
  userToken: string;
  userRole: string;
}

const DashboardPage = ({
  userToken,
  userRole,
}: DashboardPageProps) => (
  <RoleGuard
    role={userRole}
    userToken={userToken}
    allowedRoles={ALLOWED_ROLES}
  >
    <StandardLayout
      headerTitle="儀表板"
      body={<DashboardFeature userToken={userToken} />}
    />
  </RoleGuard>

);

export default DashboardPage;
